import React from 'react';
import { Button, Card, CardBody, Col, Row } from 'reactstrap';
import { Field } from 'react-final-form';
import { defaultMessages } from '@I18n/default';
import ReduxFormInput from '@Utils/ReduxFormInput';
import ReduxFormInputTranslation from '@Utils/ReduxFormInputTranslation';

export interface UnitComponentProps {
  name: string;
  disabled: boolean;
  form: any;
  fields: any;
  index: number;
}

const UnitComponent: React.FC<UnitComponentProps> = ({
  name,
  disabled,
  form,
  fields,
  index,
}) => {
  return (
    <Col xs={12} key={name}>
      <Card className={'mb-2'}>
        <CardBody>
          <Row>
            <Col xs={12} md={6} lg={4}>
              <Field
                name={`${name}.name`}
                type="text"
                disabled={disabled}
                loc={form.getFieldState('loc')}
                component={ReduxFormInputTranslation}
                label={defaultMessages.publicationArmyBookFormArmyListNameLabel}
                placeHolder={
                  defaultMessages.publicationArmyBookFormArmyListNamePlaceholder
                }
              />
            </Col>
            <Col xs={12} md={6} lg={4}>
              <Field
                name={`${name}.inherits`}
                type="text"
                disabled={disabled}
                component={ReduxFormInput}
                label={
                  defaultMessages.publicationArmyBookFormArmyListInheritsLabel
                }
                placeHolder={
                  defaultMessages.publicationArmyBookFormArmyListInheritsPlaceholder
                }
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6} lg={4}>
              <Field
                name={`${name}.categories`}
                type="text"
                disabled={disabled}
                component={ReduxFormInput}
                label={
                  defaultMessages.publicationArmyBookFormArmyListCategoriesLabel
                }
                placeHolder={
                  defaultMessages.publicationArmyBookFormArmyListCategoriesPlaceholder
                }
              />
            </Col>
            <Col xs={12} md={6} lg={4}>
              <Field
                name={`${name}.unitSize`}
                type="text"
                disabled={disabled}
                component={ReduxFormInput}
                label={
                  defaultMessages.publicationArmyBookFormArmyListUnitSizeLabel
                }
                placeHolder={
                  defaultMessages.publicationArmyBookFormArmyListUnitSizePlaceholder
                }
              />
            </Col>
            <Col xs={12} md={6} lg={4}>
              <Field
                name={`${name}.cost`}
                type="number"
                disabled={disabled}
                component={ReduxFormInput}
                label={defaultMessages.publicationArmyBookFormArmyListCostLabel}
                placeHolder={
                  defaultMessages.publicationArmyBookFormArmyListCostPlaceholder
                }
              />
            </Col>
            <Col xs={12} md={6} lg={4}>
              <Field
                name={`${name}.height`}
                type="string"
                disabled={disabled}
                component={ReduxFormInput}
                label={
                  defaultMessages.publicationArmyBookFormArmyListHeightLabel
                }
                placeHolder={
                  defaultMessages.publicationArmyBookFormArmyListHeightPlaceholder
                }
              />
            </Col>
            <Col xs={12} md={6} lg={4}>
              <Field
                name={`${name}.fluff`}
                type="string"
                disabled={disabled}
                component={ReduxFormInput}
                label={
                  defaultMessages.publicationArmyBookFormArmyListFluffLabel
                }
                placeHolder={
                  defaultMessages.publicationArmyBookFormArmyListFluffPlaceholder
                }
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12}>Global profile</Col>
            <Col xs={12} md={6} lg={4}>
              <Field
                name={`${name}.profile.global.chargeRate`}
                type="string"
                disabled={disabled}
                component={ReduxFormInput}
                label={
                  defaultMessages.publicationArmyBookFormArmyListProfileGlobalChargeRateLabel
                }
                placeHolder={
                  defaultMessages.publicationArmyBookFormArmyListProfileGlobalChargeRatePlaceholder
                }
              />
            </Col>
            <Col xs={12} md={6} lg={4}>
              <Field
                name={`${name}.profile.global.marchRate`}
                type="string"
                disabled={disabled}
                component={ReduxFormInput}
                label={
                  defaultMessages.publicationArmyBookFormArmyListProfileGlobalMarchRateLabel
                }
                placeHolder={
                  defaultMessages.publicationArmyBookFormArmyListProfileGlobalMarchRatePlaceholder
                }
              />
            </Col>
            <Col xs={12} md={6} lg={4}>
              <Field
                name={`${name}.profile.global.discipline`}
                type="string"
                disabled={disabled}
                component={ReduxFormInput}
                label={
                  defaultMessages.publicationArmyBookFormArmyListProfileGlobalDisciplineLabel
                }
                placeHolder={
                  defaultMessages.publicationArmyBookFormArmyListProfileGlobalDisciplinePlaceholder
                }
              />
            </Col>
            <Col xs={12} md={6} lg={4}>
              {/*  <FieldArray name={`${name}.profile.global.rules`>*/}
              {/*  {({ fields }) =>*/}
              {/*    fields.map((name, index) => (*/}
              {/*      <div>*/}
              {/*        <Field*/}
              {/*          name={`${name}`}*/}
              {/*          type="string"*/}
              {/*          disabled={disabled}*/}
              {/*          component={ReduxFormInput}*/}
              {/*          label={*/}
              {/*            defaultMessages.publicationArmyBookFormArmyListProfileDefensiveHpLabel*/}
              {/*          }*/}
              {/*          placeHolder={*/}
              {/*            defaultMessages.publicationArmyBookFormArmyListProfileDefensiveHpPlaceholder*/}
              {/*          }*/}
              {/*        />*/}
              {/*        <Button type="button" onClick={() => fields.remove(index)}>Remove</Button>*/}
              {/*      </div>*/}
              {/*      )*/}
              {/*    )}*/}
              {/*</FieldArray>*/}
            </Col>
          </Row>
          <Row>
            <Col xs={12}>Defensive profile</Col>
            <Col xs={12} md={6} lg={4}>
              <Field
                name={`${name}.profile.defensive.hp`}
                type="string"
                disabled={disabled}
                component={ReduxFormInput}
                label={
                  defaultMessages.publicationArmyBookFormArmyListProfileDefensiveHpLabel
                }
                placeHolder={
                  defaultMessages.publicationArmyBookFormArmyListProfileDefensiveHpPlaceholder
                }
              />
            </Col>
            <Col xs={12} md={6} lg={4}>
              <Field
                name={`${name}.profile.defensive.defensiveSkill`}
                type="string"
                disabled={disabled}
                component={ReduxFormInput}
                label={
                  defaultMessages.publicationArmyBookFormArmyListProfileDefensiveDefensiveSkillLabel
                }
                placeHolder={
                  defaultMessages.publicationArmyBookFormArmyListProfileDefensiveDefensiveSkillPlaceholder
                }
              />
            </Col>
            <Col xs={12} md={6} lg={4}>
              <Field
                name={`${name}.profile.defensive.resistance`}
                type="string"
                disabled={disabled}
                component={ReduxFormInput}
                label={
                  defaultMessages.publicationArmyBookFormArmyListProfileDefensiveResistanceLabel
                }
                placeHolder={
                  defaultMessages.publicationArmyBookFormArmyListProfileDefensiveResistancePlaceholder
                }
              />
            </Col>
            <Col xs={12} md={6} lg={4}>
              <Field
                name={`${name}.profile.defensive.armour`}
                type="string"
                disabled={disabled}
                component={ReduxFormInput}
                label={
                  defaultMessages.publicationArmyBookFormArmyListProfileDefensiveArmourLabel
                }
                placeHolder={
                  defaultMessages.publicationArmyBookFormArmyListProfileDefensiveArmourPlaceholder
                }
              />
            </Col>
            <Col xs={12} md={6} lg={4}>
              {/*<FieldArray name={`${name}.profile.defensive.rules`>*/}
              {/*  {({ fields }) =>*/}
              {/*    fields.map((name, index) => (*/}
              {/*        <div>*/}
              {/*          <Field*/}
              {/*            name={`${name}`}*/}
              {/*            type="string"*/}
              {/*            disabled={disabled}*/}
              {/*            component={ReduxFormInput}*/}
              {/*            label={*/}
              {/*              defaultMessages.publicationArmyBookFormArmyListProfileDefensiveHpLabel*/}
              {/*            }*/}
              {/*            placeHolder={*/}
              {/*              defaultMessages.publicationArmyBookFormArmyListProfileDefensiveHpPlaceholder*/}
              {/*            }*/}
              {/*          />*/}
              {/*          <Button type="button" onClick={() => fields.remove(index)}>Remove</Button>*/}
              {/*        </div>*/}
              {/*      )*/}
              {/*    )}*/}
              {/*</FieldArray>*/}
            </Col>
          </Row>
          <Row>
            <Col xs={12}>Options</Col>
            <Col xs={12} md={6} lg={4}></Col>
          </Row>
          <Row>
            <Col xs={12}>Command Group</Col>
            <Col xs={12} md={6} lg={4}></Col>
          </Row>
          <Row>
            <Col xs={12}>Wizard Conclave</Col>
            <Col xs={12} md={6} lg={4}></Col>
          </Row>
          <Button
            type="button"
            className="btn btn-age"
            onClick={() => fields.remove(index)}
          >
            Remove
          </Button>
        </CardBody>
      </Card>
    </Col>
  );
};

export default UnitComponent;
